import { useEffect } from "react";
import { useSocketContext } from "../context/SocketContext";

/**
 * Escuta team_board_card no socket e atualiza o painel aberto.
 */
export function useRealtimeTeamBoard({ boardId, onUpdate }) {
  const { socket } = useSocketContext();

  useEffect(() => {
    if (!socket || !boardId) return;

    const handleBoardEvent = (payload) => {
      let data = payload;
      if (typeof payload === "string") {
        try {
          data = JSON.parse(payload);
        } catch {
          return;
        }
      }
      if (Number(data?.boardId) !== Number(boardId)) return;
      if (onUpdate) onUpdate(data);
    };

    socket.on("team_board_card", handleBoardEvent);
    return () => {
      socket.off("team_board_card", handleBoardEvent);
    };
  }, [socket, boardId, onUpdate]);
}
